export class Range {
  constructor(public min: number, public max: number) {
    if (min > max) {
      throw new Error(`Min cannot be greater than max: ${min} > ${max}`);
    }
  }
}
